import { Subscription, Observable, interval } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { DropzoneComponent, DropzoneConfigInterface, DROPZONE_CONFIG, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { PredictService } from './../../service/predict.service';
import { DBConnectorService } from './../../service/test.service';
import { SectorModel } from './../../service/sector.model';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ShowLogDialogComponent } from '../../show-log-dialog/show-log-dialog.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-instant-predict',
  templateUrl: './instant-predict.component.html',
  styleUrls: ['./instant-predict.component.css']
})
export class InstantPredictComponent implements OnInit {
  
  @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;
  bsModalRef: BsModalRef
  predictclick = false;
  sectormodel = new SectorModel;
  enableGetLogs: boolean;
  enableExcelGetLogs:boolean;
  sub: Subscription;
  Modelsub: Subscription;
  Status = "";
  Instaresult:any = {};
  result:any = {};
  public IsContraEnabled: boolean;
  public showContraCheckBox : boolean;

  public config: DropzoneConfigInterface = {
    url: "/api/PredictUsingExcel/SaveUploadedPredictedFile",
    clickable: true,
    headers: {
      'Sector': this.sectorservice.SectorName,
      'Model': this.sectorservice.ModelName,
      'User': this.sectorservice.username
    },
    uploadMultiple: false,
    autoReset: null,
    errorReset: 15000,
    cancelReset: 15000,
    maxFiles: 1,
    createImageThumbnails: true,
    dictDefaultMessage: "Drag and Drop or Click to browse for files",
    acceptedFiles: ".xlsm",

  };
  
  constructor(private sectorservice: DBConnectorService,
    private predictservice: PredictService,
    private http: HttpClient,
    private router: Router,
    private _dialogService: BsModalService
    ) {

    this.sectormodel.SectorName = this.sectorservice.SectorName;
    this.sectormodel.ModelName = this.sectorservice.ModelName;
    this.sectormodel.User = this.sectorservice.username;
    this.Instaresult = this.predictservice.InstaResult;
    this.sectorservice.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res });
    this.Modelsub = this.sectorservice.onGetMod.subscribe((res) => {
      this.sectormodel.ModelName = res;
      this.configset();
      this.PredictStatus();
      this.predictclick = false;
    });
  }

  configset() {
    let url1 = "/api/PredictUsingExcel/SaveUploadedPredictedFile";
    // var resource = this.adalService.GetResourceForEndpoint(url1);
    // let token = this.adalService.getCachedToken(resource);
    // let tokenbearer = 'Bearer ' + token;

    this.config = {
      url: url1,
      clickable: true,
      headers: {
        'Authorization': this.sectorservice.getToken(url1),
        'Sector': this.sectorservice.SectorName,
        'Model': this.sectorservice.ModelName,
        'User': this.sectorservice.username
      },
      uploadMultiple: false,
      autoReset: null,
      errorReset: 15000,
      cancelReset: 15000,
      maxFiles: 1,
      createImageThumbnails: true,
      dictDefaultMessage: "Drag and Drop or Click to browse for files",
      acceptedFiles: ".xlsm",
      addRemoveLinks: true,
      timeout: 240000
    };
  }
  onUploadError(args: any) {
    // console.log('onUploadError:', args);
  }
  onUploadSuccess(args: any) {
    // console.log('onUploadSuccess:', args);
    this.result = args[1];
  } 

  //FileUpload
  fileChange(event: any) {
    alert("Uploading Files");
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      console.log(fileList)
      for (var i in fileList) {
        let file: File = fileList[i];
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        //console.log(formData);
        //headers.append('Content-Type', 'json');

        let options = {
          headers: new HttpHeaders({
            'Accept': 'application/json',
            'Sector': this.sectorservice.SectorName,
            'Model': this.sectorservice.ModelName,
            'User': this.sectorservice.username
          })
        }
        let apiUrl = "/api/PredictUsingExcel/SaveUploadedPredictedFile";
        this.http.post<any>(apiUrl, formData, options)
          //.catch(error => Observable.throw(error))
          .subscribe(
          (data) => {
            console.log(data);
            this.result = data;
            alert("Files Uploaded");
          }
          //error => console.log("error");
          )
      }
    }
  };

  DownloadPredict() {
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.result = {};

      let options: object = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        reponseType: 'Blob',
        observe: 'response'
      }

      let url = "/api/Download/DownloadPredict" + "?Sector=" + this.sectorservice.SectorName + "&Model=" + this.sectorservice.ModelName + "&User=" + this.sectorservice.username;
      this.http.post<any>(url, '', options)
        .subscribe((res) => {

          let parsedResponse = res.body;
          var contentType = 'application/octet-stream';
          let blob = new Blob([parsedResponse], { type: contentType });
          let url = window.URL.createObjectURL(blob);
          // window.open(url);
          let contentDispositionHeader = res.headers.get("content-disposition");
          let filename = contentDispositionHeader.split('=')[1].trim();

          let a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);


        }
        );
    } else {
      this.result["PredictError"] = "Sector and Model have not been selected!";
    }
  }
  
  onpredict() {
    var Iscontra=this.IsContraEnabled;
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.result = {};
      this.enableExcelGetLogs = true;
      this.predictclick = true;
      console.log("Predict - start");
      //console.log(this.sectormodel);
      this.predictservice.Predict(this.sectormodel,Iscontra)
        .subscribe(
          (data) => {
            this.result = data;
            this.predictservice.result = data;
            console.log(this.result);
            console.log("Predict - after api");
            this.predictclick = false;
            this.IsContraVisible();
            if (this.result["Desc"] == null && this.result["PredictError"] == null) {
              this.router.navigate(['Predict/PredictUsingExcel']);
            }
          },
          (error) => console.log(error));
    } else {
      this.result["PredictError"] = "Sector and Model have not been selected!";
    }

  }

  CancelPredict() {
    this.sectormodel.User = this.sectorservice.username;
    this.predictservice.cancelPredict(this.sectormodel)
      .subscribe(
        (data) => { });
  }

  PredictStatus() {
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.result = {};
      this.sectormodel.User = this.sectorservice.username;
      this.predictservice.statusCheck(this.sectormodel)
        .subscribe(
          (data) => {
            this.Status = data;
            if (this.Status == "ACTIVE") {
              this.predictclick = true;
              this.enableExcelGetLogs = true;
            }
            else if (this.Status == "SUCCESS" && this.predictclick == true) {
              this.router.navigate(['Predict/PredictUsingExcel']);
            }
            else if (this.Status == "SUCCESS") {
              this.result["Desc"] = null;
              if(data!='Error' && this.predictclick == true)
                 this.result["Success"] = "Last Process Status:: " + data;
              else
              this.result["Success"] =null;
            }
            else {
              this.predictclick = false;
              
                this.result["Success"] = null;
                this.result["Desc"] = null;
               
             
                // this.result["Success"] = null;
                // this.result["Desc"] = "Last Process Status:: " + data;
            
            }
            console.log(this.Status);
          });
    } else {
      this.result["PredictError"] = "Sector and Model have not been selected!";
    }
  }
  IsContraVisible(){

    this.predictservice.contraStatusCheck(this.sectormodel)
    // .subscribe(
    //   (data) => {
    //        var dataSectroData = data;
    //        //this.showContraCheckBox = data;
    //   });

  }

  ngOnInit() {
    this.IsContraVisible();
    this.configset();
    this.PredictStatus();

    this.sub = interval(5000).subscribe(x => {
      if (this.predictclick == true) {
        this.PredictStatus();
      }
    });
  }
  ngOnDestroy() {
    if (this.sub != null) {
      this.sub.unsubscribe();
    }
    if (this.Modelsub != null) {
      this.Modelsub.unsubscribe();
    }
  }
  OpenLogsDialog() {
    console.log("clicked!")
    const initialState = {
      source: "predict",
      username: this.sectorservice.username
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    // this._dialogService.addDialog(ShowLogDialogComponent, { source: "predict", username: this.sectorservice.username }).subscribe(data => console.log(data))
  }

  OpenExcelLogsDialog() {
    console.log("Excel clicked!")
    const initialState = {
      source: "excel_predict",
      username: this.sectorservice.username
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    // this._dialogService.addDialog(ShowLogDialogComponent, { source: "excel_predict", username: this.sectorservice.username }).subscribe(data => console.log(data))
  }

}
